import { render, staticRenderFns } from "./clientMessage.vue?vue&type=template&id=3941deda&scoped=true"
import script from "./clientMessage.vue?vue&type=script&lang=js"
export * from "./clientMessage.vue?vue&type=script&lang=js"
import style0 from "./clientMessage.vue?vue&type=style&index=0&id=3941deda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3941deda",
  null
  
)

export default component.exports